import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { StemMarkScheme } from '@examdojo/models/markscheme-v2';

export function validateMarkschemeRefsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const markscheme = control.value as StemMarkScheme;

    if (!markscheme.all_mark_groups || !markscheme.solution_paths) {
      return null;
    }

    const validIds = new Set(markscheme.all_mark_groups.map((mg) => mg.id));
    const referencedIds = new Set<string>();

    for (const solutionPath of markscheme.solution_paths) {
      for (const markGroupRef of solutionPath.mark_group_refs) {
        referencedIds.add(markGroupRef);

        if (!validIds.has(markGroupRef)) {
          return { markschemeValidationError: true };
        }
      }
    }

    for (const markGroup of markscheme.all_mark_groups) {
      if (!referencedIds.has(markGroup.id)) {
        return { markschemeValidationError: true };
      }
    }

    return null;
  };
}
